module.exports = __webpack_public_path__ + "assets/img/jyske-bank.3476d346.jpg";